document.addEventListener("DOMContentLoaded", () => {

  /* ======================================================
     ELEMENTS
  ====================================================== */

  const sizeInputs = document.querySelectorAll('input[name="size"]');
  const variantSelect = document.getElementById("product-variant-selector");
  const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
  const atcPrice = document.querySelector(".Addtocartbutton .price-reg");
  const mainPrice = document.querySelector(".main_price .price-reg");
  const mainCompare = document.querySelector(".main_price .price-sale s");
  const defaultVariantRadioId = "variant-53486746304822";

  if (mainPrice) mainPrice.style.display = "none";


  /* ======================================================
     HELPERS
  ====================================================== */

  function getSelectedSizeCard() {
    const checked = document.querySelector('input[name="size"]:checked');
    const card = checked ? checked.nextElementSibling : null;
    return card;
  }

  function getCardPrices(card) {
    if(!isSubscribeActive()){
      const regularEl = card?.querySelector(".reguler-price") || card?.querySelector(".old-price");
      const discountedEl = card?.querySelector(".discounted-price");
      const regular = regularEl ? parseFloat(regularEl.textContent.replace(/[^0-9.]/g, "")) : null;
      const discounted = discountedEl ? parseFloat(discountedEl.textContent.replace(/[^0-9.]/g, "")) : null;
      return { regular, discounted };
    }
    else{
      // Look inside the subscription div first
      const subscriptionDiv = card.querySelector(".subscription");
      const container = subscriptionDiv || card; // fallback to card if subscription not found

      const regularEl = container.querySelector(".reguler-price") || container.querySelector(".old-price");
      const discountedEl = container.querySelector(".discounted-price");

      const regular = regularEl ? parseFloat(regularEl.textContent.replace(/[^0-9.]/g, "")) : null;
      const discounted = discountedEl ? parseFloat(discountedEl.textContent.replace(/[^0-9.]/g, "")) : null;

      // Handle Shopify cents (2999 → 29.99)
      const finalRegular = regular && regular > 1000 ? regular / 100 : regular;
      const finalDiscounted = discounted && discounted > 1000 ? discounted / 100 : discounted;

      return { regular: finalRegular, discounted: finalDiscounted };
    }
  }

  /* ======================================================
     SEAL STATE
  ====================================================== */

  function isSubscribeActive() {
    const activeContainer = document.querySelector(".sls-option-container.sls-active");
    const active = !!activeContainer?.querySelector('input.sls-option[data-type="subscription"]');
    return active;
  }

  function getActiveSellingPlanId() {
    const activeContainer = document.querySelector(".sls-option-container.sls-active");
    const select = activeContainer?.querySelector("select.sls-select");
    const id = select?.value || "";
    return id;
  }

  /* ======================================================
     UI UPDATERS
  ====================================================== */

  function updateSellingPlan() {
    sellingPlanInput.value = getActiveSellingPlanId();
  }

  function updateATCPrice() {
    const card = getSelectedSizeCard();
    if (!card || !atcPrice) return;

    const { regular, discounted } = getCardPrices(card);
    const price = isSubscribeActive() ? discounted : regular;
    if (price !== null) {
      if(isSubscribeActive()){
        atcPrice.textContent = `$${discounted.toFixed(2)} + Free Shipping`;
      }
      else{
        atcPrice.textContent = `$${discounted.toFixed(2)}`;
      }
    }
  }

  function updateBadges() {
    sizeInputs.forEach(input => {
    const card = input.nextElementSibling;
    if (!card) return;

    const subscriptionDiv = card.querySelector(".subscription"); // your subscription content
    const cardBody = card.querySelector(".card-body");

    if (!subscriptionDiv || !cardBody) return;

    if (isSubscribeActive()) {
      // Subscription selected → show subscription div, ensure card-body visible
      cardBody.style.display = "none";
      subscriptionDiv.style.display = "block";
      
    } else {
      // One-time purchase → hide subscription div, still show card-body
      subscriptionDiv.style.display = "none";
      cardBody.style.display = "block";
    }

    // console.log("updateSubscriptionVisibility", {
    //   isSubscribeActive: isSubscribeActive(),
    //   subscriptionDivDisplay: subscriptionDiv.style.display
    // });
  });
  }

  function updateMainPrice() {
    const card = getSelectedSizeCard();
    // `card` = whatever element was clicked (or you already have a reference)
    const label = card.closest('label.size-card') || card;
    // value based on the selected card
    const value = label.querySelector('.pack-title')?.textContent?.trim();
    if (!value) return;

    // dropdown (no id)
    const select = document.querySelector('select[name="options[Size]"]');
    if (!select) return;

    // set + fire change
    select.value = value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
    if (!card || !mainPrice) return;

    const discountedEl = card.querySelector(".discounted-price");
    const oldPriceEl = card.querySelector(".old-price");

    if (isSubscribeActive() && discountedEl) {
      mainPrice.textContent = discountedEl.textContent.trim();
    } else if (oldPriceEl) {
      mainPrice.textContent = oldPriceEl.textContent.trim();
    } else if (discountedEl) {
      mainPrice.textContent = discountedEl.textContent.trim();
    }

    if (mainCompare) {
      if (isSubscribeActive() && oldPriceEl) {
        mainCompare.textContent = oldPriceEl.textContent.trim();
        mainCompare.parentElement.style.display = "inline-block";
      } else {
        mainCompare.parentElement.style.display = "none";
      }
    }

  }

  // function syncAll() {
  //   updateSellingPlan();
  //   updateATCPrice();
  //   updateBadges();
  //   updateMainPrice();
  // }
function syncAll() {
  return new Promise((resolve) => {
    updateSellingPlan();
    updateATCPrice();
    updateBadges();
    updateMainPrice();
    resolve(); // resolve immediately after all functions run
  });
}
  /* ======================================================
     SEAL OBSERVER (ROBUST FIRST-CLICK FIX)
  ====================================================== */

  function observeSealChanges() {
    const container = document.querySelector(".sls-purchase-options-container");
    if (!container) return;

    const observer = new MutationObserver(() => {
      syncAll();
    });

    observer.observe(container, { attributes: true, childList: true, subtree: true });
  }

  function waitForSealContainer() {
    const container = document.querySelector(".sls-purchase-options-container");
    if (container) {
      observeSealChanges();

      // Optional: trigger initial click on first subscription option to ensure badges update
      const firstSub = container.querySelectorAll('input.sls-option[data-type="one_time"]');
      const firstParent = firstSub[0].closest('.sls-option-container');

      if (firstSub) {
      // firstParent.style.display = 'none';
        firstSub[0].hidden = true;
        firstSub[0].click();
      }
    } else {
      requestAnimationFrame(waitForSealContainer);
    }
  }

  waitForSealContainer();

  /* ======================================================
     EVENT LISTENERS
  ====================================================== */

  // Size → Variant
sizeInputs.forEach((input, index) => {
  input.addEventListener("change", () => {

    variantSelect.value = input.value;
    variantSelect.dispatchEvent(new Event("change", { bubbles: true }));

    syncAll();

  });
});


  // Variant change
  variantSelect.addEventListener("change", () => {
    syncAll();
  });

  /* ======================================================
     INITIALIZATION
  ====================================================== */

  // Select first size
  const firstSize = document.querySelector('.size-grid input[type="radio"]');
  if (firstSize) {
    firstSize.checked = true;
    firstSize.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // Force default variant
  setTimeout(() => {
    const defaultRadio = document.getElementById(defaultVariantRadioId);
    if (defaultRadio) {
      defaultRadio.checked = true;
      defaultRadio.dispatchEvent(new Event("change", { bubbles: true }));
    }
    syncAll();
  }, 50);
  
  
});
